export class MenuConfig {
	public defaults: any = {
		header: {
			self: {},
			items: [
				
				
				// {
				// 	title: 'MENU.DASHBOARD',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/platom/dashboard',
				// 	translate: 'MENU.DASHBOARD',
				// },
				// {
				// 	title: 'MENU.FIELDFORCE',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/platom/fieldforce',
				// 	translate: 'MENU.FIELDFORCE',
				// },
				
				{
					title: 'MENU.RAPORLAR',
					root: true,
					alignment: 'left',
					page: '/platom/analysis',
					translate: 'MENU.RAPORLAR',
					
				},
				
				{
					title: 'MENU.PHOTOS',
					root: true,
					alignment: 'left',
					page: '/platom/field-photos',
					translate: 'MENU.PHOTOS',
					
				}

				// Sistem Yönetici ve Müşteri Yönetici menuleri için API tarafında user session üzerine yetki için alan açılacak.
				// Sadece yetkisi olan kullanıcılar için görüntülenebilir olacaklar.
				// Henuz tamamlanmadigi icin kapatildi - HA - 04.08.2025
				
				// ,{
				// 	title: 'Sistem Yönetici',	// .xml dosyaları içerisine başlık tanımlamaları ingilizce-türkçe olarak yapılacak. 
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/platom/systemadmin/menu',
				// 	translate: 'Sistem Yönetici',
				// },

				// {
				// 	title: 'Müşteri Yönetici',	// .xml dosyaları içerisine başlık tanımlamaları ingilizce-türkçe olarak yapılacak.
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/platom/customeradmin',
				// 	translate: 'Müşteri Yönetici',
				// }
				
				//Bu bolumdeki moduller MERT KARAKAYA trafindan hazirlandi.
				// {
				// 	title: 'Islemler',
				// 	root: true,
				// 	alignment: 'left',
				// 	/*page: 'platom/analysis',
				// 	translate: 'Raporlar V2',*/
				// 	submenu: [
					   
				// 		{
				// 			title: 'Ürün Raporu',
				// 			page: '/platom/product-analysis'
				// 		},
				// 		{
				// 		   title: 'Merch Performans',
				// 		   page: '/platom/merch-rate'
				// 	   },
				// 	   {
				// 		   title: 'Haritalı Rut Raporu',
				// 		   page: '/platom/map-routes'
				// 	   },
				// 	   {
				// 		   title: 'Haritalı Merch Raporu',
				// 		   page: '/platom/map-daily'
				// 	   },
				// 		{
				// 		   title: 'Ziyaret Görevleri',
				// 		   page: '/platom/analysis/16/272'
				// 	   },
					  /* {
						title: 'Saha Verileri',
						page: '/platom/analysis/18/336'
					}*/
					
					]
				//}
				
				// {
				// 	title: 'MENU.TEST',
				// 	root: true,
				// 	alignment: 'left',
				// 	page: '/test/menu',
				// 	translate: 'MENU.TEST',
				// 	submenu: [
				// 		{
				// 			title: 'MENU.LOGIN',
				// 			page: '/login'
				// 		},
				// 		{
				// 			title: 'MENU.MENU',
				// 			page: '/test/menu'
				// 		},
				// 		{
				// 			title: 'MENU.USERS',
				// 			page: '/test/users'
				// 		},
				// 		{
				// 			title: 'Sub Test',
				// 			page: '/test/subtest/mysubpage1'
				// 		},
				// 		{
				// 			title: 'Admin Add User',
				// 			page: '/app/admin/useradd'
				// 		},
						
				// 	]
				// }
			//]
		},
	
};

	public get configs(): any {
	return this.defaults;
	}
}
